import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";

const Footer = ({ data }) => {
  const [socialRef, socialVisible] = useScrollReveal();

  if (data) {
    var networks = data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url} target="_blank" rel="noopener noreferrer">
            <i className={network.className}></i>
          </a>
        </li>
      );
    });
  }

  return (
    <footer>
      <div
        ref={socialRef}
        className={`footer-inner ${socialVisible ? "reveal-visible" : "reveal"}`}
      >
        <ul className="social-links">{networks}</ul>
        <p className="copyright">
          Made by{" "}
          <a
            title="Vivek"
            href="https://github.com/Vivek1898"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vivek
          </a>
        </p>
      </div>
      <div id="go-top">
        <a className="smoothscroll" title="Back to Top" href="#home">
          <i className="icon-up-open"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
